import React from 'react'
import mixpanel from 'mixpanel-browser';

import {
  FooterContainer,
  FooterSections,

  FooterSection,
  Title,
  Link,

  FooterSectionItem,
  // ContactArea,
  // ContactInput,
  // ContactButton,
  Email,

  Copyright,

  ProductHuntLogo,
  BehanceLogo,
  GithubLogo,
} from './styled';

export default ({
  showModal,
  mode,
}) => (
  <FooterContainer>

    <FooterSections>

      <FooterSection>
        <Title>
          Chronos Timetracker
        </Title>
        <Link href="/eula">
          EULA
        </Link>
        <Link
          href="https://github.com/web-pal/chronos-timetracker/blob/master/CONTRIBUTING.md"
          target="__blank"
          onClick={() => mixpanel.track('Clicked "Contribute on Github(Timetracker)" - Footer')}
        >
          Contribute on Github
        </Link>
        <Link
          href="https://github.com/web-pal/chronos-timetracker/issues"
          target="__blank"
          onClick={() => mixpanel.track('Clicked "Report an issue(Timetracker)" - Footer')}
        >
          Report an issue
        </Link>
        <Link
          bold
          blue
          onClick={() => {
            showModal();
            mixpanel.track('Clicked "Download Timetracker" - Footer')
          }}
        >
          Download
        </Link>
      </FooterSection>

      <FooterSection>
        <Title>
          {
            mode === 'trello' ? 'Chronos Power-Up for trello' : 'Chronos Timesheets'
          }
        </Title>
        <Link
          href={
            mode === 'trello'
              ? "https://trello.com/power-ups/5d2dded97bdded0fdb6638f8"
              : "https://marketplace.atlassian.com/plugins/jira-chronos/cloud/overview"
          }
          target="__blank"
        >
          View on Marketplace
        </Link>
        {mode === 'jira' && (
          <>
            <Link
              href="https://web-pal.atlassian.net/servicedesk/customer/portal/2"
              target="__blank"
              onClick={() => mixpanel.track('Clicked "Get help(Timesheets)" - Footer')}
            >
              Get help
            </Link>
            <Link
              bold
              orange
              href="https://marketplace.atlassian.com/plugins/jira-chronos/cloud/overview"
              target="__blank"
              onClick={() => mixpanel.track('Clicked "Try now(Timesheets)" - Footer')}
            >
              Try now
            </Link>
          </>
        )}
      </FooterSection>

      <FooterSection>
        <Title>
          Feedback
        </Title>

        <Link href="/about">
          About
        </Link>

        <FooterSectionItem>
          If you have any questions, feel free
          <br />
          to contact us at <Email
            href="mailto:it@web-pal.com"
            onClick={() => mixpanel.track('Clicked "Contact via email" - Footer')}
          >
            it@web-pal.com</Email>
        </FooterSectionItem>

        <div>
          <a
            href="https://github.com/web-pal/chronos-timetracker"
            target="__blank"
            onClick={() => mixpanel.track('Social Media click - Github')}
          >
            <GithubLogo />
          </a>
          <a
            href="https://www.producthunt.com/posts/chronos-jira-timetracking-system"
            target="__blank"
            onClick={() => mixpanel.track('Social Media click - Product hunt')}
          >
            <ProductHuntLogo />
          </a>
          <a
            href="https://www.behance.net/gallery/59340307/Chronos-timetoolsdesign"
            target="__blank"
            onClick={() => mixpanel.track('Social Media click - Behance')}
          >
            <BehanceLogo />
          </a>
        </div>

        {/*
        <ContactArea>
          <ContactInput type="text" placeholder="Email address" />
          <ContactButton>Submit</ContactButton>
        </ContactArea>
        */}

      </FooterSection>

    </FooterSections>

    <Copyright>Copyright © 2017</Copyright>

  </FooterContainer>
)
